import {
  getRecord,
  saveRecord,
} from './index';
import {
  DEVICE_ID_STORAGE_KEY,
  getOrCreateDeviceId as getOrCreatePersistentDeviceId,
  getOrCreateDeviceIdSync,
} from '@/services/device/deviceIdentity';

export { DEVICE_ID_STORAGE_KEY };
export const DEFAULT_DEVICE_TYPE = 'unknown';

function nowIso() {
  return new Date().toISOString();
}

export function getOrCreateDeviceId() {
  return getOrCreateDeviceIdSync();
}

export async function initLocalDevice() {
  const deviceId = await getOrCreatePersistentDeviceId();
  const currentTime = nowIso();

  const existingDevice = await getRecord('devices', deviceId);
  const deviceRecord = {
    ...existingDevice,
    id: deviceId,
    restaurant_id: existingDevice?.restaurant_id || null,
    device_name: existingDevice?.device_name || '',
    device_type: existingDevice?.device_type || DEFAULT_DEVICE_TYPE,
    first_seen_at: existingDevice?.first_seen_at || currentTime,
    last_seen_at: currentTime,
    updated_at: currentTime,
  };

  await saveRecord('devices', deviceRecord);
  return deviceRecord;
}
